function firstValidationMessage(errors) {
  if (!errors || typeof errors !== 'object') {
    return null;
  }

  const messages = Object.values(errors).flat().filter(Boolean);
  return typeof messages[0] === 'string' ? messages[0] : null;
}

export function getLoginErrorMessage(error) {
  if (error?.code === 'ECONNABORTED') {
    return 'El servidor tardó demasiado en responder. Por favor intenta de nuevo.';
  }

  if (!error?.response) {
    return 'No se pudo conectar con el servidor. Verificá tu conexión.';
  }

  const status = error.response.status;
  const payload = error.response.data || {};
  const serverMessage = typeof payload.message === 'string' ? payload.message : null;
  const validationMessage = firstValidationMessage(payload.errors);

  if (status === 401) {
    return serverMessage || 'Credenciales incorrectas. Por favor intenta de nuevo.';
  }

  if (status === 403) {
    return serverMessage || 'La sucursal o el canal no está habilitado.';
  }

  if (status === 404) {
    return serverMessage || 'La sucursal no existe.';
  }

  if (status === 422) {
    return validationMessage || serverMessage || 'Revisá los datos ingresados.';
  }

  if (status === 429) {
    return 'Demasiados intentos. Esperá un momento e intentá de nuevo.';
  }

  if (status >= 500) {
    return 'El servidor no pudo procesar el inicio de sesión. Intentá de nuevo.';
  }

  return serverMessage || 'No se pudo iniciar sesión. Intentá de nuevo.';
}
